/**
 * @file refactor from umu_mobile
 */
import * as ua from '@umu/umu-ua';

export const $window = window;
export const $location = $window.location;
export const $document = document;
export const $history = history;
export const docElement = $document.documentElement || $document.body;

/**
 * 强制刷新
 * @param url
 */
export const forceRefreshPage = (url: string) => {
    // const reg = /([^\?]*)(\?[^#]*)?(#.*)?/i;  // todo 优化使用正则，按照url构成分成三部分
    // url = url || window.location.href;
    const currentUrl = url || window.location.href;
    // url = currentUrl.split('#');
    const split = currentUrl.split('#');
    const oldHash = split[1] || '';
    url = split[0];
    const urlSplit = url.split('?');
    const pathname = urlSplit[0];
    const search = urlSplit[1] || '';
    if (!pathname) {
        return;
    }

    const newSearch = search ? search.replace(/[&]?_r=[\.\d]+/gi, '') : '';
    const newUrl =
        pathname +
        (newSearch ? '?' + newSearch + '&' : '?') +
        '_r=' +
        Math.random().toFixed(3) +
        (oldHash ? '#' + oldHash : '');
    window.location.href = newUrl;
};

/**
 * url跳转
 */
export function redirectTo(url: string, isNotForceRefresh?: boolean) {
    if (!url) {
        return;
    }
    openWindow(url, '_self')
    if (!isNotForceRefresh) {
        setTimeout(() => {
            forceRefreshPage(url);
        }, 2000);
    }
}

/**
 * url跳转
 */
export function redirectToWeb(path: string, isOpenWindow = false) {
    const host = $location.protocol + '//' + $location.host.replace('m.', '');
    const url = host + path;
    if (!isOpenWindow) {
        $window.location.href = url;
        setTimeout(() => {
            forceRefreshPage(url);
        }, 2000);
    } else {
        openWindow(url);
    }
}
/**
 * @desc 桌面端内部跳转（钉🆙、飞书）
 */
export const isInternalJump = () => ua.isDingdingDesktop || ua.isFeishu;
/**
 * @desc 创建a标签跳转
*/
export const isCreateLinkJump = () => {
    return ua.isIosQQ;
}
/**
 * @desc openWindow
 */
export function openWindow(url: string, target = '_blank') {
    if (isCreateLinkJump()) {
        const a = document.createElement('a');
        a.href = url;
        a.dispatchEvent(new Event('click'));
        return;
    }
    if (isInternalJump() || target === '_self') {
        $window.location.href = url;
        return;
    }
    $window.open(url, target);
}

/**
 * 通过点击a标签的方式打开窗口
 * @param {string} url 完整的url
 * @param {string} target 以何种方式打开 '_blank' | '_self'
 */
export const openWindowWithLink = (url: string, target: '_blank' | '_self' = '_blank') => {
    url = /^http/.test(url) ? url : `http://${url}`;
    if (target === '_self' || isInternalJump()) {
        location.href = url;
        return;
    }
    const alink = document.createElement('a');
    alink.href = url;
    alink.target = target;
    alink.click();
};

/**
 * 判断当前页面是否在iframe里 ，
 * 主要作用还是判断是否嵌入自己页面里边的比如im中，需要做些业务处理，但是嵌入第三方域名不能影响这些业务
 * true = in iframe
 * false = not in iframe
 */
export function isInIframe() {
    let inFrame = false;
    try {
        inFrame = window.self !== window.parent;
    } catch (e) {
        inFrame = true;
    }

    // 嵌入了第三方域名不做嵌入算, 只有同一一级域名才能设置这个
    try {
        document.domain = document.domain;
    } catch (e) {
        inFrame = false;
    }
    return inFrame;
}
